import { css } from 'styled-components';
import { PrimaryLabel } from './styled.js';
import { themeGet } from '../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../foundation/spacing/utils.js';

var styles = {
  primary: {
    solid: {
      background: 'colors.secondary.50',
      borderColor: 'colors.secondary.50',
      hover: {
        background: 'colors.secondary.100',
        borderColor: 'colors.secondary.100'
      },
      active: {
        background: 'colors.secondary.200',
        borderColor: 'colors.secondary.200'
      },
      focus: {
        shadowColor: 'colors.focus.secondary'
      },
      primaryLabelColor: 'colors.secondary.500',
      iconColor: 'colors.secondary.500'
    },
    outline: {
      background: 'colors.background.50',
      borderColor: 'colors.secondary.500',
      hover: {
        background: 'colors.secondary.50',
        borderColor: 'colors.secondary.500'
      },
      active: {
        background: 'colors.secondary.100',
        borderColor: 'colors.secondary.500'
      },
      focus: {
        shadowColor: 'colors.focus.secondary'
      },
      primaryLabelColor: 'colors.secondary.500',
      iconColor: 'colors.secondary.500'
    }
  },
  secondary: {
    solid: {
      background: 'colors.background.100',
      borderColor: 'colors.background.100',
      hover: {
        background: 'colors.brandPrimary.100',
        borderColor: 'colors.brandPrimary.100'
      },
      active: {
        background: 'colors.brandPrimary.200',
        borderColor: 'colors.brandPrimary.200'
      },
      focus: {
        shadowColor: 'colors.focus.secondary'
      },
      primaryLabelColor: 'colors.text.200',
      iconColor: 'colors.brandPrimary.600'
    },
    outline: {
      background: 'colors.background.50',
      borderColor: 'colors.border.200',
      hover: {
        background: 'colors.brandPrimary.50',
        borderColor: 'colors.border.200'
      },
      active: {
        background: 'colors.brandPrimary.100',
        borderColor: 'colors.border.200'
      },
      focus: {
        shadowColor: 'colors.focus.secondary'
      },
      primaryLabelColor: 'colors.text.200',
      iconColor: 'colors.brandPrimary.600'
    }
  },
  success: {
    solid: {
      background: 'colors.green.50',
      borderColor: 'colors.green.50',
      hover: {
        background: 'colors.green.100',
        borderColor: 'colors.green.100'
      },
      active: {
        background: 'colors.green.200',
        borderColor: 'colors.green.200'
      },
      focus: {
        shadowColor: 'colors.focus.success'
      },
      primaryLabelColor: 'colors.text.success',
      iconColor: 'colors.green.500'
    },
    outline: {
      background: 'colors.background.50',
      borderColor: 'colors.green.500',
      hover: {
        background: 'colors.green.50',
        borderColor: 'colors.green.500'
      },
      active: {
        background: 'colors.green.100',
        borderColor: 'colors.green.500'
      },
      focus: {
        shadowColor: 'colors.focus.success'
      },
      primaryLabelColor: 'colors.text.success',
      iconColor: 'colors.green.500'
    }
  },
  danger: {
    solid: {
      background: 'colors.red.50',
      borderColor: 'colors.red.50',
      hover: {
        background: 'colors.red.100',
        borderColor: 'colors.red.100'
      },
      active: {
        background: 'colors.red.200',
        borderColor: 'colors.red.200'
      },
      focus: {
        shadowColor: 'colors.focus.danger'
      },
      primaryLabelColor: 'colors.text.danger',
      iconColor: 'colors.red.500'
    },
    outline: {
      background: 'colors.background.50',
      borderColor: 'colors.red.500',
      hover: {
        background: 'colors.red.50',
        borderColor: 'colors.red.500'
      },
      active: {
        background: 'colors.red.100',
        borderColor: 'colors.red.500'
      },
      focus: {
        shadowColor: 'colors.focus.danger'
      },
      primaryLabelColor: 'colors.text.danger',
      iconColor: 'colors.red.500'
    }
  },
  warning: {
    solid: {
      background: 'colors.yellow.50',
      borderColor: 'colors.yellow.50',
      hover: {
        background: 'colors.yellow.100',
        borderColor: 'colors.yellow.100'
      },
      active: {
        background: 'colors.yellow.200',
        borderColor: 'colors.yellow.200'
      },
      focus: {
        shadowColor: 'colors.focus.warning'
      },
      primaryLabelColor: 'colors.yellow.900',
      iconColor: 'colors.yellow.900'
    },
    outline: {
      background: 'colors.background.50',
      borderColor: 'colors.yellow.500',
      hover: {
        background: 'colors.yellow.50',
        borderColor: 'colors.yellow.500'
      },
      active: {
        background: 'colors.yellow.100',
        borderColor: 'colors.yellow.500'
      },
      focus: {
        shadowColor: 'colors.focus.warning'
      },
      primaryLabelColor: 'colors.yellow.900',
      iconColor: 'colors.yellow.900'
    }
  },
  info: {
    solid: {
      background: 'colors.blue.50',
      borderColor: 'colors.blue.50',
      hover: {
        background: 'colors.blue.100',
        borderColor: 'colors.blue.100'
      },
      active: {
        background: 'colors.blue.200',
        borderColor: 'colors.blue.200'
      },
      focus: {
        shadowColor: 'colors.focus.info'
      },
      primaryLabelColor: 'colors.blue.500',
      iconColor: 'colors.blue.500'
    },
    outline: {
      background: 'colors.background.50',
      borderColor: 'colors.blue.500',
      hover: {
        background: 'colors.blue.50',
        borderColor: 'colors.blue.500'
      },
      active: {
        background: 'colors.blue.100',
        borderColor: 'colors.blue.500'
      },
      focus: {
        shadowColor: 'colors.focus.info'
      },
      primaryLabelColor: 'colors.blue.500',
      iconColor: 'colors.blue.500'
    }
  },
  assistant: {
    solid: {
      background: 'colors.assistant.50',
      borderColor: 'colors.assistant.50',
      hover: {
        background: 'colors.assistant.100',
        borderColor: 'colors.assistant.100'
      },
      active: {
        background: 'colors.assistant.200',
        borderColor: 'colors.assistant.200'
      },
      focus: {
        shadowColor: 'colors.focus.assistant'
      },
      primaryLabelColor: 'colors.assistant.500',
      iconColor: 'colors.assistant.500'
    },
    outline: {
      background: 'colors.background.50',
      borderColor: 'colors.assistant.500',
      hover: {
        background: 'colors.assistant.50',
        borderColor: 'colors.assistant.500'
      },
      active: {
        background: 'colors.assistant.100',
        borderColor: 'colors.assistant.500'
      },
      focus: {
        shadowColor: 'colors.focus.assistant'
      },
      primaryLabelColor: 'colors.assistant.500',
      iconColor: 'colors.assistant.500'
    }
  }
};
function getCSS(appearance) {
  return css(["background:", ";border-color:", ";&:is(button){&:hover{background-color:", ";border-color:", ";}&:active{background-color:", ";border-color:", ";}&:focus-visible{box-shadow:0 0 0 ", " ", ";}}", "{color:", ";}[data-icon='falcon']{color:", ";}"], themeGet(appearance.background), themeGet(appearance.borderColor), themeGet(appearance.hover.background), themeGet(appearance.hover.borderColor), themeGet(appearance.active.background), themeGet(appearance.active.borderColor), pxToRem(4), themeGet(appearance.focus.shadowColor), PrimaryLabel, themeGet(appearance.primaryLabelColor), themeGet(appearance.iconColor));
}
var getChipAppearance = function getChipAppearance(appearance, variant) {
  var defaultStyle = styles.primary.solid;
  var selectedAppearance = styles[appearance] || {};
  var style = selectedAppearance[variant] || {};
  return getCSS(style || defaultStyle);
};

export { getChipAppearance };
